interface RunData {
  id: string;
  invocationType: string;
  status: string;
  output: string | null;
  durationMs: number | null;
  startedAt: string;
  completedAt: string | null;
}

interface Props {
  run: RunData;
  onClick?: () => void;
}

function formatDuration(ms: number): string {
  if (ms < 1000) return `${ms}ms`;
  const secs = Math.floor(ms / 1000);
  if (secs < 60) return `${secs}s`;
  const mins = Math.floor(secs / 60);
  const remainSecs = secs % 60;
  return `${mins}m ${remainSecs.toString().padStart(2, '0')}s`;
}

function formatTime(date: string): string {
  return new Date(date).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
}

function formatDate(date: string): string {
  const d = new Date(date);
  const today = new Date();
  if (d.toDateString() === today.toDateString()) return `Today ${formatTime(date)}`;
  const yesterday = new Date(today);
  yesterday.setDate(yesterday.getDate() - 1);
  if (d.toDateString() === yesterday.toDateString()) return `Yesterday ${formatTime(date)}`;
  return d.toLocaleDateString([], { month: 'short', day: 'numeric' }) + ' ' + formatTime(date);
}

export function RunItem({ run, onClick }: Props) {
  const statusClass = run.status === 'success' ? 'ok' : run.status === 'error' ? 'fail' : 'running';

  return (
    <div className="run-item" onClick={onClick}>
      <span className={`run-dot ${statusClass}`} />
      <div className="run-body">
        <div className="run-label">
          {run.output ? run.output.slice(0, 60) + (run.output.length > 60 ? '...' : '') : `Run ${run.id.slice(0, 8)}`}
        </div>
        <div className="run-meta">
          {run.invocationType} · {formatDate(run.startedAt)}
        </div>
      </div>
      {run.durationMs != null && (
        <span className="run-duration">{formatDuration(run.durationMs)}</span>
      )}
    </div>
  );
}
